import { render, staticRenderFns } from "./UpdateError.vue?vue&type=template&id=49df72a0"
import script from "./UpdateError.vue?vue&type=script&lang=js"
export * from "./UpdateError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports